import script from "./NewContactUsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewContactUsPage.vue?vue&type=script&setup=true&lang=js"

import "./NewContactUsPage.vue?vue&type=style&index=0&id=154c24cf&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154c24cf"]])

export default __exports__